export default {
  backgroundColor: "#dbedf8",
};
